export const LOADING_START = 'LOADING_START';
export const LOADING_DONE = 'LOADING_DONE';

export const startLoading = () => dispatch =>
  dispatch({
    type: LOADING_START
  });
export const endLoading = () => dispatch =>
  dispatch({
    type: LOADING_DONE
  });
